



















import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({})
export default class MdcImageListItem extends Vue{
  @Prop({default:'li'}) tag!:string
  @Prop() src!:string
  @Prop({type:Boolean,default:true}) aspectContainer!:boolean
  @Prop({default:undefined}) to?:string

  @Prop({default:true}) ripple?:boolean

  get cssClass(){
    return {}
  }
}
